var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:(_vm.dateString),expression:"dateString"}]},[_vm._v(_vm._s(_vm.fromNow(_vm.dateMoment)))])}
var staticRenderFns = []

export { render, staticRenderFns }